import { aboutRoute } from './about-route';
import { homeRoute } from './home-route';
import { ssrRoute } from './ssr-route';

export const routes = [aboutRoute, ssrRoute, homeRoute];
